import React from "react"
import gql from "graphql-tag"
import PropTypes from "prop-types"
import {injectValidationStatusHandler} from "@irati-web/insights/src/graph/cycleValidationStatusHandler"

import {Query as QueryComponent} from "../"
import {schedule as scheduleFields, scheduleParams} from "../../gql/schedule"

export const query = gql`
  query Schedule(
    $tenant: String!,
    $id: String!,
    $interestId: String,
    ${scheduleParams}
  ) {
    schedule(tenant: $tenant, id: $id, interestId: $interestId) {
      ${scheduleFields}
      questionGroups {
        results {
          uuid
          tenantUuid
          name
          contentId
        }
      }
    }
  }`

const CycleQuery = ({children, ...props}) => {
  return (
    <QueryComponent
      {...props}
      query={query}>
      {({data: {schedule} = {}, ...apolloState}) => {
        return children({schedule: injectValidationStatusHandler(schedule), ...apolloState})
      }}
    </QueryComponent>
  )
}

CycleQuery.propTypes = {
  children: PropTypes.func.isRequired
}


export default CycleQuery
